import gql from "graphql-tag";

export const List = gql`
  query ListPurchaseOrders(
    $filter: TablePurchaseOrderFilterInput, 
    $limit: Int,
    $nextToken: String
  )
  {
    listPurchaseOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        purchaseOrderId
        userId
        user {
          userId
          email
          given_name
          family_name
        }
        given_name
        family_name
        company_name
        email
        phone
        coupons
        createdAt
        status
        smartAccountsInvoiceNumber
      }
    }
  }
`;


export const GetPurchaseOrder = gql`
  query GetPurchaseOrder($purchaseOrderId: ID!, $userId: ID!) {
    getPurchaseOrder(purchaseOrderId: $purchaseOrderId, userId: $userId) {
      purchaseOrderId
      userId
      given_name
      family_name
      company_name,
      city
      state
      country
      zip
      email
      phone
      coupons
      teamIds
      teams
      createdAt
      smartAccountsInvoiceNumber
    }
  }
`;

export const ExportToSmartAccounts = gql`
  mutation ExportToSmartAccounts($input: PurchaseOrderInput!) {
    exportToSmartAccounts(input: $input) {
      errors {
        message
        code
      }
      totalAmount
      invoiceNumber
    }
  }
`;


export const UpdatePurchaseOrderStatus = gql`
  mutation UpdatePurchaseOrderStatus($purchaseOrderId: ID!, $status: PaymentStatusEnum!) {
    updatePurchaseOrderStatus(purchaseOrderId: $purchaseOrderId, status: $status) {
      purchaseOrderId
      userId
      given_name
      family_name
      company_name,
      city
      state
      country
      zip
      email
      phone
      coupons
      teamIds
      teams
      createdAt
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/PurchaseOrders/graphql.js